function normalizeForMatch(text: string): string {
  return String(text || '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

const RED_PHRASES = [
  'dont want to go home',
  'do not want to go home',
  'dont tell',
  'do not tell',
  'he gets so angry',
  'she gets so angry',
  'they get so angry',
  'hit me',
  'hits me',
  'hurt me',
  'hurts me',
  'kill myself',
  'want to die'
];

const YELLOW_PHRASES = [
  'ruins it',
  'always ruins',
  'cannot join',
  'cant join',
  'can not join',
  'leave her out',
  'leave him out',
  'leave them out',
  'not allowed to play'
];

export type MascotSuggestion = {
  kind: 'none' | 'rewrite' | 'skip';
  prompt?: string;
  suggestion?: string;
};

function matchesAny(normalized: string, phrases: string[]): boolean {
  return phrases.some((phrase) => normalized.includes(phrase));
}

export function mascotSuggestion(text: string): MascotSuggestion {
  const normalized = normalizeForMatch(text);
  if (!normalized) return { kind: 'none' };
  if (matchesAny(normalized, RED_PHRASES)) return { kind: 'skip' };
  if (matchesAny(normalized, YELLOW_PHRASES)) {
    return {
      kind: 'rewrite',
      prompt: 'That might leave someone out. Want to say it another way?',
      suggestion: 'Could we let everyone have a turn?'
    };
  }
  return { kind: 'none' };
}
